import { Card, Avatar, Tooltip, Divider } from 'antd';
import React from 'react'
import moment from "jalali-moment";
import renderHTML from "react-render-html";
import { Col, Row } from 'reactstrap';


const { Meta } = Card;


const MassageComponent = ({ item, createUserName, findAuthor }) => {
    return (
        <div>
            <Row>
                <Col className='pt-2 text-center' xl={2} lg={2} md={2} sm={12} xs={12}>
                    <Avatar
                        size={48}
                        src={findAuthor(item.user)}
                    ></Avatar>
                    <br />
                    <small>{createUserName(item)}</small>
                </Col>
                <Col className='pt-2 text-right ' xl={10} lg={10} md={10} sm={12} xs={12}>
                    <Row><small>{moment(new Date(item.created))
                        .locale(window.document.documentElement.lang === "fa" ? "fa" : "en")
                        .fromNow()}</small></Row>
                    <Row>{renderHTML(item.content)}</Row>
                </Col>
            </Row>
            <Divider />
            {/* <Card
            style={{
                width: "100%",
            }}
        
        >
            <Meta
                avatar={<div><Avatar
                    size={36}
                    src={findAuthor(item.user)}
                ></Avatar><br/><small>{createUserName(item)}</small></div>}
                title={<Tooltip
                    title={moment(new Date(item.created))
                        .locale("fa")
                        .format("HH:mm jYYYY/jMM/DD")}
                >
                    <span>
                        {moment(new Date(item.created))
                            .locale("fa")
                            .fromNow()}
                    </span>
                </Tooltip>}
                description={renderHTML(item.content)}
            />
        </Card> */}
        </div>
    );
}

{/* <Comment
 author={createUserName(item)}
 avatar={
   <Avatar
     size={36}
     src={findAuthor(item.user)}
   ></Avatar>
 }
 content={renderHTML(item.content)}
 datetime={
   <Tooltip
     title={moment(new Date(item.created))
       .locale("fa")
       .format("HH:mm jYYYY/jMM/DD")}
   >
     <span>
       {moment(new Date(item.created))
         .locale("fa")
         .fromNow()}
     </span>
   </Tooltip>
 }
/> */}

export default MassageComponent;